import axios from 'axios'
import { url } from '@js/utilities/url.js'
import { errorNotify } from '@js/utilities/bugsnag.js'

/**
 * Post accept offer to shroom
 *
 * @param partner_customer_reference
 * @param {string} partnerId
 * @param {string} applicationId
 * @param {string} message
 */
async function acceptLog(partner_customer_reference, partnerId, applicationId, message) {
    try {
        await axios
            .post(url('/api/shroom/accept'), {
                partner_customer_reference: partner_customer_reference,
                partner_id: partnerId,
                application_id: applicationId,
                message: message,
            })
            .then(response => {
                if (response?.status !== 200) {
                    errorNotify('Failed Shroom network request', 'error', 'Shroom', { data: response })
                }
            })
    } catch (error) {
        errorNotify('Failed Shroom network request', 'error', 'Shroom', { error })
        return null
    }
}

/**
 * Post decline offer to shroom
 *
 * @param partner_customer_reference
 * @param {string} partnerId
 * @param {string} applicationId
 */
async function declineLog(partner_customer_reference, partnerId, applicationId) {
    try {
        await axios
            .post(url('/api/shroom/decline'), {
                partner_customer_reference: partner_customer_reference,
                partner_id: partnerId,
                application_id: applicationId,
            })
            .then(response => {
                if (response?.status !== 200) {
                    errorNotify('Failed Shroom network request', 'error', 'Shroom', { data: response })
                }
            })
    } catch (error) {
        errorNotify('Failed Shroom network request', 'error', 'Shroom', { error })
        return null
    }
}

export { acceptLog, declineLog }
